module.exports = __webpack_public_path__ + "static/media/post-group-disabled.1554fdba.svg";